import getMessage from 'src/background/utils/i18n.utils';
import { FavoriteAccountsItemComponent } from '@popup/steem/pages/app-container/settings/user-preferences/favorite-accounts/favorite-accounts-item/favorite-accounts-item.component';
import React from 'react';
import { connect } from 'react-redux';
const FavoriteAccountsList = ({ favoriteList, activeAccount, handleDeleteFavorite, handleEditFavoriteLabel, }) => {
    const favoriteListName = favoriteList.name.split('_').join(' ');
    return (React.createElement("div", { className: "favorite-accounts-list", key: `${Math.random().toFixed(6).toString()}-${favoriteListName}` },
        (!favoriteList.list || favoriteList.list.length === 0) && (React.createElement("div", { className: "text-no-favorites" }, getMessage('popup_html_favorite_accounts_no_favorites'))),
        favoriteList.list &&
            favoriteList.list.map((favoriteItem) => {
                return (React.createElement(FavoriteAccountsItemComponent, { key: `${Math.random()
                        .toFixed(6)
                        .toString()}-${favoriteListName}-item`, favorite: favoriteItem, listName: favoriteList.name, handleDeleteFavorite: handleDeleteFavorite, handleEditFavoriteLabel: handleEditFavoriteLabel }));
            })));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, {});
export const FavoriteAccountsListComponent = connector(FavoriteAccountsList);
